import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '@/components/common'

import styles from './BlogPaginate.module.scss'

const BlogPaginate = ({ path, currentPage, totalPages }) => (
  <div className={styles.wrapper}>
    {currentPage === 2 && <Link className={styles.link} to={path}>&laquo; Previous</Link>}
    {currentPage > 2 && <Link className={styles.link} to={`${path}/page/${currentPage - 1}`}>&laquo; Previous</Link>}
    {currentPage < totalPages && <Link className={styles.link} to={`${path}/page/${currentPage + 1}`}>Next &raquo;</Link>}
  </div>
)

BlogPaginate.propTypes = {
  path: PropTypes.string,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
}

export default BlogPaginate
